module.exports = __webpack_public_path__ + "static/img/WeChatbfaed0e8af0e4c8e8548f1f00bfb909e.2d8aa27.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/WeChatbfaed0e8af0e4c8e8548f1f00bfb909e.png
// module id = /H6C
// module chunks = 1